import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { NotFound } from 'app/components/not-found';

import { HealthReport } from './health-report';
import { KpiDashboard } from './kpi-dashboard';

export class ToolsRouter extends React.Component {
    public render(): React.ReactNode {
        return (
            <Switch>
                <Route exact path='/tools'>
                    <Redirect to='/tools/health' />
                </Route>
                <Route path='/tools/health'>
                    <HealthReport />
                </Route>
                <Route path='/tools/kpi'>
                    <KpiDashboard />
                </Route>
                <Route path='*'>
                    <NotFound />
                </Route>
            </Switch>
        );
    }
}
